import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import tagSettings from 'actions/customers/tagSettings'
import Component from 'components/Customers/FormView/Tags'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getSettings: tagSettings.getSettings })(Component)
